import { createSlice } from "@reduxjs/toolkit";

const initialState = {
    id: null,
    userName: '',
    role: '',
    email: '',
    token: ''   // keep token here
};

const userSlice = createSlice({
    name: 'user',
    initialState,
    reducers: {
        setUser: (state, action) => {
            state.id = action.payload.id;
            state.userName = action.payload.userName;
            state.role = action.payload.role;
            state.email = action.payload.email;
            state.token = action.payload.token; // store token
        },
        clearUser: (state) => {
            state.id = null;
            state.userName = '';
            state.role = '';
            state.email = '';
            state.token = ''; // ✅ clear token too
        }
    }
});

export const { setUser, clearUser } = userSlice.actions;
export default userSlice.reducer;

